import { IBriefInflunecerPendingReviewFacets } from "@shared/lib/types/brief";
import { IBriefInfluencerSearchRequestV2 } from "@shared/lib/types/briefInfluencerV2";

export type AgencyPendingReviewFlag = keyof Omit<
  IBriefInflunecerPendingReviewFacets["agency"],
  "total" | "briefInfluencerCount"
>;

export const AGENCY_PENDING_REVIEW_GROUPS: {
  id: AgencyPendingReviewFlag;
  label: string;
  shortText: string;
}[] = [
  {
    id: "brandShortlisted",
    label: "Brand Shortlisted",
    shortText: "Brand shortlisted this creator",
  },
  {
    id: "brandDeclined",
    label: "Declined",
    shortText: "Brand declined this creator",
  },
  {
    id: "brandSuggested",
    label: "Suggested",
    shortText: "Brand suggested this creator",
  },
  {
    id: "brandPurchased",
    label: "Purchased",
    shortText: "Brand purchased this creator",
  },
  {
    id: "brandNegoRequested",
    label: "Requested Fresh Quote",
    shortText: "Brand requested a fresh quote",
  },
  {
    id: "brandChangedDeliverable",
    label: "Changed Deliverables",
    shortText: "Brand changed deliverables",
  },
  {
    id: "brandAddedNotes",
    label: "Added Notes",
    shortText: "Brand added notes",
  },
];

type AgencyPendingReviewFlags = Partial<
  Record<AgencyPendingReviewFlag, boolean>
>;

export function getAgencyPendingReviewChips(
  facets?: IBriefInflunecerPendingReviewFacets
): { id: AgencyPendingReviewFlag; label: string; count: number }[] {
  const agencyFacets = facets?.agency;
  if (!agencyFacets) {
    return [];
  }

  return AGENCY_PENDING_REVIEW_GROUPS.map((group) => ({
    id: group.id,
    label: group.label,
    count: agencyFacets[group.id] ?? 0,
  })).filter((group) => group.count > 0);
}

export function getAgencyPendingReviewSearchParams(
  flag: AgencyPendingReviewFlag | null
): Pick<IBriefInfluencerSearchRequestV2, "pendingReviewActions"> {
  if (!flag) {
    return {};
  }

  return {
    pendingReviewActions: {
      agency: { [flag]: true },
    },
  };
}

export function getAgencyPendingReviewSnippet(
  flags?: AgencyPendingReviewFlags
): string | undefined {
  if (!flags) {
    return undefined;
  }

  const activeGroups = AGENCY_PENDING_REVIEW_GROUPS.filter(
    (group) => flags[group.id]
  );
  if (activeGroups.length === 0) {
    return undefined;
  }

  const extra =
    activeGroups.length > 1 ? ` · +${activeGroups.length - 1}` : "";
  return `${activeGroups[0].shortText}${extra}`;
}

export function hasAgencyPendingReview(
  flags?: AgencyPendingReviewFlags
): boolean {
  return Boolean(
    flags && AGENCY_PENDING_REVIEW_GROUPS.some((group) => flags[group.id])
  );
}
